import { Subject } from 'rxjs';
import { StorageService } from './../../../services/storage/storage.service';
import {
  Component,
  Input,
  OnDestroy,
  ViewChild,
  SimpleChanges,
  ChangeDetectionStrategy,
  OnChanges,
} from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { SharedService } from '../../../services/shared/shared.service';
import { PredefinedTemplatesService } from '../../../services/edit/predefined-templates.service';
import { AdvancedsearchComponent } from '../../../pages/advancedsearch/advancedsearch.component';
import { YourListService } from '../../../pages/your-list/your-list.service';
import { takeUntil } from 'rxjs/operators';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'ag-edit-c-showcase',
  templateUrl: './edit-c-showcase.component.html',
  styleUrls: ['./edit-c-showcase.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditCShowcaseComponent extends SidenavContent implements OnDestroy, OnChanges {
  @ViewChild('advanceShowcase') advanceShowcase: AdvancedsearchComponent;
  @Input() show: any;
  @Input() template: any;
  @Input() type: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() edit: boolean;
  @Input() date: any;
  @Input() widgetEdit: boolean;
  @Input() dynamic = true;
  @Input() defaultColors: any = true;
  @Input() starterTheme = '';
  @Input() isPopularList = false;

  isCollapsed = true;
  recordsCount: number;
  title: string;
  titleBackground: string;
  background: string;
  color: string;
  autoplay = true;
  flushed: boolean;
  showcaseType: any = 'dynamic';
  lists: any;
  listId: number;

  private typeOf = 'showcase';
  private backImg: string;
  private infinite = true;
  private autoplaySpeed: number;
  private variableWidth: any;
  private className: string;
  private items: any = [];
  private responsive: any;
  private searchId: any;
  private agControlId: any;
  private shard: any;
  private ShowCaseResults: any;
  private showcaseDisplay: any;
  private searchResults: any;
  private _unsubscribeAll: Subject<void> = new Subject<void>();
  private _OneColumn: boolean;
  private _TwoColumns: boolean;
  private _ThreeColumns: boolean;
  private _FourColumns: boolean;
  private _FiveColumns: boolean;
  private _SixColumns: boolean;

  constructor(
    private _layoutService: LayoutService,
    private _editService: SetComponentsService,
    private _sharedService: SharedService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
    private _storageService: StorageService,
    private _yourListService: YourListService,
  ) {
    super(_layoutService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.template) {
        this.template = changes.template.currentValue;
      }
      if (changes.rowType) {
        this.rowType = changes.rowType.currentValue;
      }
      if (changes.rowArray) {
        this.rowArray = changes.rowArray.currentValue;
      }
      if (changes.compArray) {
        this.compArray = changes.compArray.currentValue;
      }
      if (changes.show) {
        this.show = changes.show.currentValue;
      }
      if (changes.type) {
        this.type = changes.type.currentValue;
      }
      if (changes.edit) {
        this.edit = changes.edit.currentValue;
      }
      if (changes.dynamic) {
        this.dynamic = changes.dynamic.currentValue;
      }
      this.widgetEdit = changes.widgetEdit ? changes.widgetEdit.currentValue : false;
      if (!this.dynamic) {
        this.showcaseType = 'static';
        if (this.isPopularList) {
          this.getPopularLists();
        } else {
          this.getLists();
        }
      } else {
        this.showcaseType = 'dynamic';
      }
      if (this.edit === true) {
        this.setRowType();
        this.getFormVariables();
      } else {
        this.setNewVariables();
      }
      this._predefinedTemplatesService
        .getShowCaseResultsBS()
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((data) => {
          this.ShowCaseResults = data;
        });
      if (changes.starterTheme) {
        this.starterTheme = changes.starterTheme.currentValue;
      }
      // if edit is false, set the more options colors for the component to the default templates foregorund and back ground color if a new component is loaded.
      //  fi edit is true, laod the more options color from the template value above which is retrived from mongo
      if (!this.edit && this.template && this.starterTheme !== '' && this.starterTheme) {
        if (changes.defaultColors) {
          this.defaultColors = changes.defaultColors.currentValue;
          if (this.defaultColors) {
            this.color = this.defaultColors.fontColor;
            this.background = this.defaultColors.backColor;
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  setAutoPlay(event) {
    this.autoplay = event.checked;
  }

  setNewVariables() {
    if (this.firstNewVariables().some((i) => i === this.rowType)) {
      this.initializeValues('height-250 padding-10-15');
    } else if (this.secondNewVariables().some((i) => i === this.rowType)) {
      this.initializeValues('height-200 padding-10-15');
    } else {
      this.initializeValues('padding-25');
    }
  }

  firstNewVariables(): string[] {
    return [
      'col-2',
      'col-21',
      'col-2-1-2',
      'col-2-1-3',
      'col-2-2-1',
      'col-2-3-1',
      'col-31',
      'col-3-1-1-2',
      'col-3-1-2-1',
      'col-3-2-1-1',
    ];
  }

  secondNewVariables(): string[] {
    return ['col-42', 'col-421', 'col-51', 'col-632'];
  }

  initializeValues(className: string) {
    this.className = className;
    this.titleBackground = '';
    this.background = '';
    this.backImg = '';
    this.color = '';
    this.flushed = true;
    this.autoplay = true;
    this.autoplaySpeed = 4000;
    this.infinite = true;
    this.variableWidth = '';
    this.responsive = '';
  }

  getFormVariables() {
    this.typeOf = 'showcase';
    this.title = this.template[this.compArray].title;
    this.titleBackground = this.template[this.compArray].titleBackground;
    this.background = this.template[this.compArray].background;
    this.backImg = this.template[this.compArray].backImg;
    this.color = this.template[this.compArray].color;
    this.flushed = this.template[this.compArray].flushed;
    this.autoplay = this.template[this.compArray].autoplay;
    this.autoplaySpeed = this.template[this.compArray].autoplaySpeed;
    this.infinite = this.template[this.compArray].infinite;
    this.variableWidth = this.template[this.compArray].variableWidth;
    this.className = this.template[this.compArray].className;
    this.responsive = this.template[this.compArray].responsive;
  }

  setRowType() {
    if (this.firstRowTypes().some((i) => i === this.rowType)) {
      this.className = 'height-250 padding-10-15';
    } else if (this.secondRowTypes().some((i) => i === this.rowType)) {
      this.className = 'height-200 padding-10-15';
    } else {
      this.className = 'padding-25';
    }
  }

  firstRowTypes(): string[] {
    return ['col-21', 'col-2-1-2', 'col-2-1-3', 'col-2-2-1', 'col-2-3-1', 'col-3-1-2-1'];
  }

  secondRowTypes(): string[] {
    return [
      'col-2',
      'col-31',
      'col-3-1-1-2',
      'col-3-2-1-1',
      'col-42',
      'col-421',
      'col-51',
      'col-632',
    ];
  }

  recordsFound(event) {
    this.recordsCount = event;
  }

  getSHOWstyles() {
    return {
      color: this.color,
      'background-color': this.background,
      'background-image': 'url(' + this.backImg + ')',
    };
  }

  getLists(): void {
    this._yourListService.lists$.pipe(takeUntil(this._unsubscribeAll)).subscribe(
      (data) => {
        this._listBindings(data);
      },
      (error: unknown) => {
        this._sharedService.openSnackBar('Unable to load lists.');
        console.error(error);
      },
    );
  }

  private _listBindings(data): void {
    if (!data?.lists?.length) {
      return;
    }

    this.lists = data.lists;
    const listSelected =
      this.edit && this.template && this.template[this.compArray].listId
        ? this.lists.find((x) => x.listId === this.template[this.compArray].listId)
        : this.lists[0];

    this.listId = listSelected?.listId;
  }

  getPopularLists(): void {
    this._yourListService.getPopularLists().subscribe((data) => {
      this._listBindings(data);
    });
  }

  doListShow() {
    const result: any = {
      typeOf: this.isPopularList ? 'popular-list' : 'showcase-list',
      className: this.className,
      flushed: this.flushed,
      color: this.color,
      title: this.title,
      titleBackground: this.titleBackground,
      background: this.background,
      backImg: this.backImg,
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      infinite: this.infinite,
      variableWidth: this.variableWidth,
      responsive: this.responsive,
      dynamic: false,
      listId: this.listId,
      cid: this._storageService.getCid(),
      lid: this._storageService.getLid(),
    };

    this._editService.setSHOWCASE(
      result,
      this.rowType,
      this.template,
      this.rowArray,
      this.compArray,
    );
    this.closeNav();
  }

  // dynamic showcase save
  saveShowCase() {
    const result: any = {
      typeOf: 'showcase',
      className: this.className,
      flushed: this.flushed,
      color: this.color,
      title: this.title,
      titleBackground: this.titleBackground,
      background: this.background,
      backImg: this.backImg,
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      infinite: this.infinite,
      variableWidth: this.variableWidth,
      responsive: this.responsive,
      query: this.advanceShowcase.buildAdvancedSearchRequest(),
      dynamic: true,
    };

    this._editService.setSHOWCASE(
      result,
      this.rowType,
      this.template,
      this.rowArray,
      this.compArray,
    );
    this.closeNav();
  }
}
